import { ToutContentCard } from '@repo/ui/src/components/ToutContent/_toutContentCard';
import { HorizontalAlignmentEnum, ButtonStyleEnum, ButtonIconEnum } from '@repo/ui/src/enums/shared-enums';
import { ImageProps, MetaProps } from '@repo/ui/src/types';
import { CurrentUrlProps, YoutubeLinkProps } from '@repo/ui/src/types';

interface StoryCardProps {
  title?: string;
  heading?: string;
  description?: string;
  image?: ImageProps;
  link?: string;
  linkLabel?: string;
  _meta: MetaProps;
  youtubeLink?: YoutubeLinkProps;
  cardBackground?: ImageProps;
  currentUrl?: CurrentUrlProps;
}

const StoryCard = ({
  title,
  heading,
  description,
  image,
  link,
  linkLabel,
  _meta,
  youtubeLink,
  cardBackground,
}: StoryCardProps) => {
  const buttons = youtubeLink
    ? undefined
    : [
        {
          link: { link: _meta.deliveryKey, label: linkLabel, displayName: link },
          style: ButtonStyleEnum.Text,
          icon: ButtonIconEnum.Skewer,
        },
      ];

  return (
    <ToutContentCard
      toutContent={{
        heading: title,
        lilHeading: heading,
        description,
        buttons,
        align: HorizontalAlignmentEnum.Left,
      }}
      youtubeLink={youtubeLink}
      cardBackground={cardBackground || image}
    />
  );
};

export default StoryCard;